import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DefaultImage from "../../../assets/default-product-image.webp";
import { add_product_thunk } from "../../../reducers/slices/basket/thunks/add_product_thunk";
import { setIsAddingToBasket } from "../../../reducers/slices/basket/basket";
import { getDefaultVariant } from "../../../helpers/getDefaultVariant";
import { getProductImageUrl } from "../../../helpers/getProductImageUrl";
import { IncrementButton } from "../../increment_button";
import { update_quantity } from "../../../api/calls/basket/update_quantity";
import { calculate_basket_thunk } from "../../../reducers/slices/basket/thunks/calculate_basket_thunk";
import { setMainModal } from "../../../reducers/slices/main";
import { IN_STOCK } from "../../../screens/pages/shop/constants";
import { ProductBanner } from "../../product-grid-view/components/product-grid-view-item";
import { formatPrice } from "../../../helpers/formatPrice";
export function ProductListViewItem(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { product } = props;
    const [quantity, setQuantity] = useState(1);
    const { user } = useSelector((state) => state.userState);
    const { sell_out_of_stock } = user;
    const { addingToBasket, basket } = useSelector((state) => state.basketState);
    const { id, isAddingToBasket } = addingToBasket;
    const { product_list } = basket || {};
    const inStock = product?.status === IN_STOCK;
    const canAddToBasket = sell_out_of_stock === true || inStock;
    const imageUrl = getProductImageUrl(product);
    return (React.createElement("div", { className: "col-span-12 grid grid-cols-subgrid border-b border-gray pb-4 text-dark-gray cursor-pointer hover:opacity-80 ease-in-out duration-150" },
        React.createElement("div", { onClick: () => navigate(`/product/${product._id}`), className: "relative col-span-9 md:col-span-7 grid grid-cols-subgrid" },
            React.createElement("div", { className: "col-span-2 text-center" },
                React.createElement("img", { className: `${imageUrl ? "object-cover opacity-100" : "object-contain opacity-20"}`, alt: product?.title, src: imageUrl ?? DefaultImage, onError: (event) => {
                        event.target.src = DefaultImage;
                        event.target.className = "object-contain opacity-20";
                    } })),
            React.createElement("div", { className: "col-span-3 my-auto" },
                React.createElement("div", { className: "flex flex-col text-left" },
                    React.createElement("div", { className: "font-semibold text-md text-primary" }, product?.title),
                    React.createElement("div", { className: "text-sm" }, product?.description))),
            React.createElement("div", { className: "col-span-4 md:col-span-2 my-auto text-left" },
                React.createElement("div", { className: "flex justify-end text-sm font-semibold my-auto" }, `${formatPrice({
                    value: product?.price,
                    decimalPlaces: 2,
                })}`)),
            React.createElement(ProductBanner, { product: product })),
        React.createElement("div", { className: "col-span-3 md:col-span-5 my-auto text-left" },
            React.createElement("div", { className: "flex flex-col md:flex-row justify-end gap-3" },
                React.createElement(IncrementButton, { onChange: (value) => setQuantity(value) }),
                React.createElement("div", { className: "flex gap-1" },
                    React.createElement(Button, { color: "primary", size: "sm", fullWidth: true, radius: "sm", isDisabled: !canAddToBasket || (isAddingToBasket && id !== product._id), isLoading: isAddingToBasket && id === product._id, type: "submit", endContent: canAddToBasket && React.createElement(Icon, { icon: "lucide:handbag", width: "15", height: "15" }), onPress: () => {
                            const defaultVariant = getDefaultVariant(product?.variations || []);
                            const existingProduct = product_list?.find((i) => product.sku === i.sku);
                            if (existingProduct) {
                                // If product already in basket, just update the quantity
                                dispatch(setIsAddingToBasket({ id: product._id, isAddingToBasket: true }));
                                update_quantity({
                                    _id: basket?._id,
                                    product: {
                                        _id: existingProduct._id,
                                        quantity: quantity.toString(),
                                    },
                                }).then((response) => {
                                    if (response.success) {
                                        dispatch(calculate_basket_thunk(response));
                                    }
                                    else {
                                        dispatch(setIsAddingToBasket({ id: "", isAddingToBasket: false }));
                                        dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                                    }
                                });
                            }
                            else {
                                dispatch(add_product_thunk({
                                    product: product,
                                    quantity: quantity,
                                    selectedVariations: defaultVariant ? [defaultVariant] : null,
                                }));
                            }
                        } }, canAddToBasket ? "Add to Cart" : "Out of Stock"))))));
}
